import { $option } from "@lib/types/Options";
import { convert2label } from "./StringHelper";

/**
 * Transforms an enum object into a list of options.
 *
 * @param {Object} _enum - The enum object to transform.
 * @param {boolean} [reverse=false] - If true, reverses the label and value in each option.
 * @return {Array<{label: string, value: any}>} A list of options.
 */
export const enum2list = (_enum: any, reverse?: boolean): $option[] =>
  Object.entries(_enum || {}).map(([key, value]) =>
    reverse
      ? { label: convert2label(key), value: value as any, "data-testid": key }
      : {
          label: convert2label(value as string),
          value: key,
          "data-testid": value,
        },
  );
